import React, { useState } from "react";

const ChatPopup = () => {
  const [isOpen, setIsOpen] = useState(false);

  const togglePopup = () => {
    setIsOpen(!isOpen);
  };

  return (
    <div>
      <button className="open-chat-button" onClick={togglePopup}>
        <span className="mobile-text">Ai</span>
        <span className="desktop-text">ChatGPT</span>
      </button>
      {isOpen && (
        <div className="chat-popup">
          {/* <iframe
            src="https://copilot.microsoft.com/chats" //https://chat.openai.com/chat
            title="Chat with AI"
            width="100%"
            height="100%"
          /> */}
          <br />
          <h3>Coming Soon...</h3>
          <button className="close-chat-button" onClick={togglePopup}>
            X
          </button>
        </div>
      )}
    </div>
  );
};

export default ChatPopup;
